export default "__VITE_ASSET__40333fb3__"